angular.module('impactx.catalog').controller('CXMLCatalogExportCtrl', CXMLCatalogExportCtrl);

CXMLCatalogExportCtrl.$inject = [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    '$route',
    'ToolbarService',
    'DownloadService',
    '$config',
    '$securityManager',
    'ToastService'
];

function CXMLCatalogExportCtrl($scope, dataGen, $routeParams, BackService, $route, ToolbarService,
                               DownloadService, $config, $securityManager, ToastService) {
    var self = this;
    dataGen.getData($scope, {usrId: $routeParams.usrId}, "/catalogexport/cxml/view").then(function () {
        defineButtons();

        if ($scope.data.exportFormat.entries.length > 0) {
            $scope.data.exportFormat.selected = $scope.data.exportFormat.entries[0];
        }
    });

    self.exportBackground = function() {

        var dataObject = {
            usrId: $routeParams.usrId,
            exportnow: false,
            exportFormat: $scope.data.exportFormat.selected.id
        }

        return dataGen.postAsForm({}, dataObject, "/catalogexport/cxml/export").then(function () {
            BackService.back();
            ToastService.openStandardToast($scope.trns.exportSuccess);
        });
    };

    self.exportNow = function() {

        var dataObject = {
            usrId: $routeParams.usrId,
            exportnow: true,
            exportFormat: $scope.data.exportFormat.selected.id
        }

        return dataGen.postAsForm({}, dataObject, "/catalogexport/cxml/export").then(function () {
            $route.reload();
        });
    };

    self.download = function (fileName) {
        DownloadService.openParamDownloadPost('/catalogexport/cxml/download', [{paramName: "usrId", paramValue: parseInt($routeParams.usrId)}, {paramName: "fileName", paramValue: fileName}]);
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.export,
                action: self.exportBackground,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.exportNow,
                action: self.exportNow,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }
}
